import ResponsiveContainer from '@commons/containers/ResponsiveContainer';
import PageBuilder from '@commons/pagebuilder';
import PlaceholderBlock from '@commons/pagebuilder/blocks/Placeholder';
import type { MemberNodeProps } from '@commons/pagebuilder/nodes/Member';
import MemberProfile from '@commons/pagebuilder/nodes/Member/Profile';
import { DRUPAL_NODE_DISPLAY, type DrupalBlock } from '@commons/types/drupal';

import Insights from '@/pagebuilder/nodes/Member/Profile/Insights';

/**
 * MemberLayout plugin block.
 */

const MemberLayoutBlock = ({ bundle }: DrupalBlock) => {
  const page = PageBuilder.getPage<MemberNodeProps>();

  if (!page) {
    return null;
  }

  const expert = {
    ...page,
    display: DRUPAL_NODE_DISPLAY.Default,
  };

  return (
    <PlaceholderBlock placeholder={bundle}>
      <ResponsiveContainer theme="grey-11" marginBottom="xl">
        <MemberProfile {...expert} insights={<Insights id={expert.id} />} />
      </ResponsiveContainer>
    </PlaceholderBlock>
  );
};

export default MemberLayoutBlock;
